import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M9.15 8.09a.12.12 0 010-.175l4.629-4.637a.744.744 0 000-1.06.754.754 0 00-1.06 0L8.09 6.848a.125.125 0 01-.18 0L3.281 2.217a.755.755 0 00-1.223.243.746.746 0 00.163.818l4.63 4.637a.12.12 0 010 .175l-4.63 4.632A.746.746 0 002.751 14a.755.755 0 00.53-.217L7.91 9.15a.125.125 0 01.18 0l4.629 4.632a.754.754 0 001.223-.243.746.746 0 00-.163-.818L9.149 8.09z",
      fill: "#333"
    }
  )
);
export {
  l as default
};
